<template>
  <b-modal ref="creditCardLinked"
           title="Credit Card Linked"
           :ok-only="true"
           centered>
    <div class="content">
      <p>
        Your credit card is now linked to your Songback account, and will be used for future purchases automatically.
      </p>
      <p>
        Please visit the <router-link :to="{name: 'fan-billing-info'}" target="_blank">Payments</router-link> page
        to unlink (or remove) your credit card.
      </p>
    </div>
  </b-modal>
</template>

<style scoped lang="scss">
  .content {
    text-align: left;
    font-weight: normal;
    font-family: 'Avenir';
  }
</style>

<script>
export default {
  name: 'CreditCardLinked',
  methods: {
    show () {
      this.$refs.creditCardLinked.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/CreditCardLinked.vue